import { css } from 'styled-components'

export const Theming = css`
  :root,
  .theme-reset {
    --c-base-theme-1: ${({ theme }) => theme.colors.black[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.black[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.black[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.black[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.black[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.black[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.black[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-invert {
    --c-theme-1: var(--c-base-theme-7);
    --c-theme-2: var(--c-base-theme-7);
    --c-theme-3: var(--c-base-theme-7);
    --c-theme-4: var(--c-base-theme-5);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-2);
    --c-theme-7: var(--c-base-theme-1);
  }

  .theme-electric-indigo {
    --c-base-theme-1: ${({ theme }) => theme.colors.electricIndigo[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.electricIndigo[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.electricIndigo[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.electricIndigo[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.electricIndigo[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.electricIndigo[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.electricIndigo[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-limegreen {
    --c-base-theme-1: ${({ theme }) => theme.colors.limegreen[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.limegreen[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.limegreen[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.limegreen[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.limegreen[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.limegreen[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.limegreen[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-bluetiful {
    --c-base-theme-1: ${({ theme }) => theme.colors.bluetiful[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.bluetiful[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.bluetiful[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.bluetiful[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.bluetiful[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.bluetiful[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.bluetiful[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-azure {
    --c-base-theme-1: ${({ theme }) => theme.colors.azure[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.azure[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.azure[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.azure[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.azure[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.azure[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.azure[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.black[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-red {
    --c-base-theme-1: ${({ theme }) => theme.colors.red[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.red[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.red[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.red[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.red[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.red[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.red[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-orange {
    --c-base-theme-1: ${({ theme }) => theme.colors.orange[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.orange[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.orange[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.orange[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.orange[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.orange[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.orange[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-yellow {
    --c-base-theme-1: ${({ theme }) => theme.colors.yellow[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.yellow[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.yellow[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.yellow[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.yellow[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.yellow[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.yellow[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-turquoise {
    --c-base-theme-1: ${({ theme }) => theme.colors.turquoise[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.turquoise[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.turquoise[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.turquoise[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.turquoise[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.turquoise[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.turquoise[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-fuchsia {
    --c-base-theme-1: ${({ theme }) => theme.colors.fuchsia[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.fuchsia[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.fuchsia[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.fuchsia[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.fuchsia[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.fuchsia[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.fuchsia[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }

  .theme-magenta {
    --c-base-theme-1: ${({ theme }) => theme.colors.magenta[1]};
    --c-base-theme-2: ${({ theme }) => theme.colors.magenta[2]};
    --c-base-theme-3: ${({ theme }) => theme.colors.magenta[3]};
    --c-base-theme-4: ${({ theme }) => theme.colors.magenta[4]};
    --c-base-theme-5: ${({ theme }) => theme.colors.magenta[5]};
    --c-base-theme-6: ${({ theme }) => theme.colors.magenta[6]};
    --c-base-theme-7: ${({ theme }) => theme.colors.magenta[7]};
    --c-base-theme-invert: ${({ theme }) => theme.colors.white[1]};

    --c-theme-1: var(--c-base-theme-1);
    --c-theme-2: var(--c-base-theme-2);
    --c-theme-3: var(--c-base-theme-3);
    --c-theme-4: var(--c-base-theme-4);
    --c-theme-5: var(--c-base-theme-5);
    --c-theme-6: var(--c-base-theme-6);
    --c-theme-7: var(--c-base-theme-7);
    --c-theme-invert: var(--c-base-theme-invert);
  }
`
